import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-icon-6-col.scss'

export default register(`section-icon-6-col`, {
    onLoad() {

    },
    onUnload() {

    }
})
